const translations = {
    de: {
      checkout: {
        checking_out_label: 'Zur Kasse...',
        checkout_label: 'Zur Kasse',
        continue_shopping_label: 'Weiter einkaufen',
        view_cart_label: 'Warenkorb anzeigen',
        size: 'Größe',
        color: 'Farbe'
      },
      smart_cart: {
        cart_title_singular: 'Warenkorb <span class="cart-item-count">({{count}})</span>',
        cart_title_plural: 'Warenkorb <span class="cart-item-count">({{count}})</span>',
      },
      announcement_bar: {
        bars: [
          {
            free_shipping_remaining: "Noch {{remaining_amount}} für kostenlosen Versand",
            free_shipping_reached: "Sie haben kostenlosen Versand erreicht",
          }
        ]
      },
      empty: {
        title: 'Ihr Warenkorb ist leer',
        button: "Jetzt einkaufen"
      }
    },
  };
  
  const updateTranslations = () => {
    const locale = Shopify?.locale;
    const translation = translations[locale] ?? translations.en;
  
    if (locale && translation) {
      if (Rebuy && translation.checkout) {      
        Rebuy.SmartCart.getCheckoutSettings().language = translation.checkout;
      }
  
      const cartDrawer = document.querySelector('.rebuy-cart');
  
      if (cartDrawer) {
        const cartTitle = cartDrawer.querySelector('.rebuy-cart__title');
  
        if (cartTitle && translation.smart_cart) {
          const itemsCount = Rebuy.SmartCart.cart.item_count;
  
          if (itemsCount > 1) {
            cartTitle.innerHTML = translation.smart_cart.cart_title_plural.replace("{{count}}", itemsCount);
          } else {
            cartTitle.innerHTML = translation.smart_cart.cart_title_singular.replace("{{count}}", itemsCount);
          }
        }
      }
    }
  };
  
  const checkCartVariants = () => {
    const locale = Shopify?.locale;
        const translation = translations[locale] ?? translations.en;
  
    if (locale && translation) {
  
      const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item');
      
      cartItems.forEach(cartItem => {
       
        const variantElements = cartItem.querySelectorAll('.rebuy-cart__flyout-item-variant');
        const variantCount = variantElements.length;
        
        if (variantCount === 1) {
          // Single variant - color only
          const spanElement = variantElements[0].querySelector('span');
          if (spanElement) {
            spanElement.textContent = translation.checkout.color;
          }
        } else if (variantCount === 2) {
          // Two variants - size, color
          const firstSpan = variantElements[0].querySelector('span');
          const secondSpan = variantElements[1].querySelector('span');
          
          if (firstSpan) {
            firstSpan.textContent = translation.checkout.size;
          }
          if (secondSpan) {
            secondSpan.textContent = translation.checkout.color;
          }
        }
      });
    }
  };
  
  const updateEmptyCartTranslations = () => {
    const locale = Shopify?.locale;
    const translation = translations[locale] ?? translations.en;
  
    if (locale && translation) {
      const emptyCartTitle = document.querySelector('.rebuy-cart__flyout-empty-cart h4');
      const emptyCartButton = document.querySelector('.rebuy-cart__flyout-empty-cart p a');
  
      if(emptyCartTitle && emptyCartButton) {
        emptyCartTitle.innerHTML = translation.empty.title;
        emptyCartButton.innerHTML = translation.empty.button;
      }
    }
  };
  
  const updateAnnouncementBar = () => {
    const locale = Shopify?.locale;
    const announcementTranslations = translations[locale]?.announcement_bar?.bars;
    const components = Rebuy.SmartCart.settings.components;
  
    if (announcementTranslations) {
      const announcementBar = components.find(c => c.type === 'tiered_progress_bar')
  
      if(!announcementBar) {
        return;
      }
  
      announcementBar.settings.bars.forEach((bar, index) => {
        const translation = announcementTranslations[index];
  
        if (translation) {
          bar.language = translation;
        }
      });
    }
  }
  
  // Update Smart Cart with locale translations
  document.addEventListener('rebuy:smartcart.ready', () => {
    updateTranslations();
    updateAnnouncementBar();
    checkCartVariants();
  
    // Every 100ms update translations
    setInterval(() => {
      updateTranslations();
      updateEmptyCartTranslations();
    }, 50);
  });
  
  document.addEventListener('rebuy:cart.change', () => {
    updateTranslations();
    updateEmptyCartTranslations();
    updateAnnouncementBar();
    checkCartVariants();
  });
  
  // Update widgets with locale translations
  document.addEventListener('rebuy.ready', (event) => {
    updateTranslations();
  });